import View from 'mixins/view';
import CoverSliderView from 'ui/cover/cover-slider-view';

export const elements = {
    container: '.covers-container',
    holder: '.covers-holder',
    slider: '.covers-slider',
};

export default class extends View {
    constructor(model) {
        super(model);
        this.setRootEl($(elements.container));
        model.addEventListener('changedDay', this.render.bind(this));
    }
    render() {
        $(elements.container).removeClass('hide');

        this.holder.empty();
        this.coverSliderView = new CoverSliderView(this.model.getCurrentDay());
        this.holder.append(this.coverSliderView.getRootEl());
        this.coverSliderView.render();
        this.addChild(this.coverSliderView);
    }
    init() {
        this.holder = $(elements.holder);
        this.coverSliderView = new CoverSliderView(this.model.getCurrentDay());
        this.coverSliderView.setRootEl($(elements.slider));
        this.coverSliderView.initSlider();
        this.addChild(this.coverSliderView);
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/cover/covers-view.js